import { Provider } from "react-redux";
import { store } from "./store";

export function ReduxStoreProvider({ children }) {
  return <Provider store={store}>{children}</Provider>;
}
